import { Capacitor } from '@capacitor/core';
import { muvekkilAPI } from '../api/api';
import { bildirimiKaydet } from './bildirimKayit';

/*
  MUVEKKIL TELEFON BILDIRIMLERI
  -----------------------------
  Muvekkil dosyasina evrak eklendiginde telefonuna bildirim gelir.

  NASIL CALISIR: uygulama acildiginda iOS'tan bildirim izni isteniyor;
  izin verilirse Apple telefona ozel bir adres (cihaz jetonu) uretiyor,
  biz de onu sunucuya kaydediyoruz. Buro bir belgeyi muvekkile actiginda
  sunucu o adrese bildirim gonderiyor.

  BILDIRIM METNI: "Dosyanıza evrak eklendi" — belge adi, foy numarasi ve
  muvekkil adi GECMEZ. Bildirim kilit ekraninda gorunebildigi icin
  telefonu eline alan herkesin gorebilecegi bir metin olmali.

  TARAYICIDA: hicbir sey yapmaz. Bu ozellik yalnizca uygulamada var.
*/

let baslatildi = false;

export const muvekkilBildirimBaslat = async (navigate) => {
  if (!Capacitor?.isNativePlatform?.() || baslatildi) return;
  baslatildi = true;

  let PushNotifications;
  try {
    ({ PushNotifications } = await import('@capacitor/push-notifications'));
  } catch (e) {
    return;
  }

  /*
    1) ONCE DOKUNMA DINLEYICISI.
    Onceden bu dinleyici cihaz kaydindan SONRA ekleniyordu; kayit Apple
    cevabini beklerken 25 saniyeye kadar surebiliyor, dokunma o arada
    geliyordu. Eklenti olayi dinleyici cikana kadar bekletiyor ama
    beklemek gereksiz: dinleyici artik en basta kuruluyor.

    Dokununca EVRAGIN EKLENDIGI DOSYA secilir ve BELGE acilir. Sunucu
    bildirimle caseFileId ve documentId gonderiyor
    (bkz. AppPushService.NotifyMuvekkilBelgeAsync). Portal adres
    cubugundaki dosya/belge bilgisini dinliyor, portal acikken de
    calisiyor.
  */
  try {
    await PushNotifications.addListener('pushNotificationActionPerformed', (olay) => {
      try {
        const veri = olay?.notification?.data || {};
        // Yalnizca muvekkile giden bildirim. Ayni telefonda personel
        // oturumu da aciksa (ornegin avukat kendi telefonunda muvekkil
        // gorunumunu deniyorsa) personel bildirimleri kendi dinleyicisine
        // birakiliyor (bkz. utils/appNotifications).
        // muvekkil-belge: dosya + belge acilir; muvekkil-durusma: dosya acilir.
        if (veri.type && veri.type !== 'muvekkil-belge' && veri.type !== 'muvekkil-durusma') return;
        const dosyaId = veri.caseFileId || veri.CaseFileId;
        const belgeId = veri.documentId || veri.DocumentId;
        const parca = [];
        if (dosyaId) parca.push(`dosya=${encodeURIComponent(dosyaId)}`);
        if (belgeId) parca.push(`belge=${encodeURIComponent(belgeId)}`);
        // Ayni bildirime iki kez dokunulursa da tepki versin diye zaman eki.
        if (parca.length) parca.push(`t=${Date.now()}`);
        navigate(parca.length ? `/muvekkil?${parca.join('&')}` : '/muvekkil');
      } catch (e) { /* yoksay */ }
    });
  } catch (e) { /* dinleyici kurulamazsa kayit yine denenir */ }

  // 2) SONRA CIHAZ KAYDI (bkz. utils/bildirimKayit).
  try {
    await bildirimiKaydet(muvekkilAPI.cihazKaydet, true);
  } catch (e) {
    /* Bildirim kurulamazsa portal normal calismaya devam eder. */
  }
};
